import { HttpAdapter } from "../main/adapters/HttpAdapter";

export class FilesUploadGateway {
    HttpAdapter = new HttpAdapter();
    baseUrlFiles = `${publicSettings.aws.baseUrls.dataCommunications}/files`;

    async send({
        accountingId,
        companyId,
        source,
        bucketName,
        extension,
        isBase64,
        files = []
    }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlFiles}/upload`,
                {
                    accountingId,
                    companyId,
                    source,
                    bucketName,
                    extension,
                    isBase64,
                    files
                }
            );
            return response;
        } catch (err) {
            return err;
        }
    }

    async image({ accountingId, bucketName, base64 }) {
        try {
            const extension = this._getImageType(base64);
            const base64Clean = base64.split(",")[1];
            const files = [{ file: base64Clean }];
            return await this.send({
                accountingId,
                bucketName,
                isBase64: true,
                extension,
                files
            });
        } catch (err) {
            return err;
        }
    }

    _getImageType(base64String) {
        const matches = base64String.match(/^data:image\/(.*);base64,/);
        return matches ? matches[1] : null;
    }
}
